$(document).ready(function () {
  $(".featured-collection-slider .product-list-slide").slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  setTimeout(()=>{
    $(".custom-related-product .related-pro-grid").slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
      }
      }
    ]
  });
},1500);

  //   $(".custom-related-pro .related-pro-grid").slick({
  //   infinite: false,
  //   slidesToShow: 6,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   dots: false,
  //   responsive: [
  //     {
  //       breakpoint: 1350,
  //       settings: {
  //         slidesToShow: 5,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });
  
  $(".customer-reviews .reviews_list").slick({    
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });

  $(".pro_slider_list_home_featured").slick({    
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });
  
});


// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");


